import React from 'react';
import cn from 'classnames';
import { ConfirmationDialog } from '..';
import styles from './styles.module.scss';

interface DowngradeMembershipConfirmationDialogProps {
  open: boolean;
  membership: string;
  onConfirm: () => void;
  onClose: () => void;
}

const DowngradeMembershipConfirmationDialog :
  React.FC<DowngradeMembershipConfirmationDialogProps> = (
    { membership, ...props },
  ) => {
    const bodyComponent = (
      <p className={cn( 'body1', styles.dialogBodyText )}>
        You are about to
        {' '}
        <b>downgrade</b>
        {' '}
        to
        {' '}
        <b>{membership}</b>
        . Changes will apply instantly. This reassigment has a charge of $0.50.-
      </p>
    );

    return (
      <ConfirmationDialog
        title="Change membership"
        body={bodyComponent}
        confirmationButtonText="go to cart"
        cancelButtonText="Cancel"
        {...props}
      />
    );
  };

export default DowngradeMembershipConfirmationDialog;
